 
import { loginSuccess, logoff } from '@store/accountSlice';

import baseApi from './baseApi';
import { LoginRequest, LoginResponse } from './Schemas/LoginSchema';
import {
  UtilisateurChangerMotDePasseCommand,
  UtilisateurChangerMotDePasseResponse,
} from './Schemas/UtilisateurChangerMotDePasse';

const securityApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    // Login a user with courriel and password
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: ({ ...body }) => ({
        url: 'security/login',
        method: 'POST',
        body,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(loginSuccess(data));
        } catch {
          // Login failed, no action needed
        }
      },
    }),
    impersonnateClient: builder.mutation<LoginResponse, number>({
      query: (idClient) => ({
        url: `security/impersonnateClient/${idClient}`,
        method: 'POST',
      }),
      invalidatesTags: [],
    }),
    changerMotDePasse: builder.mutation<
      UtilisateurChangerMotDePasseResponse,
      UtilisateurChangerMotDePasseCommand
    >({
      query: ({ ...body }) => ({
        url: 'security/changerMotDePasse',
        method: 'PUT',
        body,
      }),
    }),
    /**
     * Logout the user by revoking the refresh token on the server
     * and clearing local state.
     */
    logout: builder.mutation<void, void>({
      query: () => ({
        url: 'security/logout',
        method: 'POST',
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
        } finally {
          // Clear local state regardless of server response
          dispatch(logoff());
        }
      },
    }),
  }),
});

export const {
  useLoginMutation,
  useImpersonnateClientMutation,
  useChangerMotDePasseMutation,
  useLogoutMutation,
} = securityApi;

export default securityApi;
